// import gsap from 'gsap';
import './css/styles.css';
import '@google/model-viewer'; // https://modelviewer.dev/

const renderYear = () => {
    const $year = document.getElementById('year');
    if(!$year) return;

    $year.textContent = (new Date().getFullYear()).toString();
};

const init = () => {
    renderYear();
};

init();

// import { ScrollTrigger } from 'gsap/ScrollTrigger';
/*

const init = () => {

    // ScrollTrigger is a GSAP plugin that lets you animate things based on scroll position:
    // - Fade in elements as they enter the viewport
    // - Pin sections while you scroll (like Apple’s product pages)
    // - Link scroll position to animation progress (scrubbing)
    // - Trigger timeline animations at specific scroll points
    gsap.registerPlugin(ScrollTrigger);

    document.addEventListener('DOMContentLoaded', () => {

        // each 3D card fades and slides up as you scroll down
        gsap.from('.portfolio-item', {

            // Start each element completely transparent (invisible)
            opacity: 0,

            // Move each element 50 pixels down from its final position at the start
            // (positive Y means downward in GSAP's coordinate system)
            y: 50,

            // Duration of the animation for each element (in seconds)
            duration: 0.8,

            // Delay the start of each element by 0.2 seconds relative to the previous one,
            // creating a nice staggered, cascading appearance
            stagger: 0.2,

            // Easing function controls acceleration — "power3.out" gives a smooth ease-out
            ease: 'power3.out',

            scrollTrigger: {

                // The element that triggers the animation when it enters the viewport
                trigger: '.portfolio-item',

                // Defines when the animation should start:
                // "top 90%" means when the top of the element reaches 90% of the viewport height
                // (i.e., just before it becomes fully visible)
                start: 'top 80%',

                // end when bottom leaves 20% viewport
                end: 'bottom 20%',

                // Defines how animation reacts when entering/leaving viewport.
                // Format: "onEnter onLeave onEnterBack onLeaveBack"
                // 'play none none reverse' means:
                //   - play when entering
                //   - do nothing when leaving
                //   - do nothing when re-entering from below
                //   - reverse when scrolling back up past it
                toggleActions: 'play none none reverse',
            }
        });

    });
};

init();*/
